




















import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'DocumentPage'
})
export default class Cash extends Vue {
  private list = [
    {
      id: 1,
      title: '平台规则',
      list: [
        {
          name: '全球旅游货仓平台规则(251104)',
          date: '2025年11月4日',
          path: 'https://qnimg.zowoyoo.com/10000/gtpw_pop_config/1762237616749_1626.pdf'
        },
        {
          name: '自我游全球货仓代收代付业务(充值)公告',
          date: '2025年9月16日',
          path: 'https://qnimg.zowoyoo.com/10000/gtpw_pop_config/1758010889921_1604.pdf'
        },
        {
          name: '自我游全球货仓虚拟产品限制公告',
          date: '2025年6月24日',
          path: 'https://qnimg.zowoyoo.com/10000/gtpw_pop_config/1750761151741_1573.pdf'
        }
      ]
    },
    {
      id: 2,
      title: '帮助文档',
      list: [
        {
          name: '全球货仓一键串货帮助手册',
          date: '',
          path: 'https://kf.ziwoyou.net/node/019918ba-d361-7ad2-b68c-a1f670855299'
        },
        {
          name: '串货订单支付失败原因',
          date: '',
          path: 'https://kf.ziwoyou.net/node/019918b7-3978-745a-a50f-73d46603a05c'
        },
        {
          name: '全球货仓保证金及充值提现',
          date: '',
          path: 'https://kf.ziwoyou.net/node/019918c2-eaad-7387-9cec-0341261dc62e'
        },
        {
          name: '全球货仓产品上架规则',
          date: '',
          path: 'https://kf.ziwoyou.net/node/019918d8-8a8c-79a3-acc9-5f83aac20c76'
        }
      ]
    },
    {
      id: 3,
      title: '历史规则',
      list: [
        {
          name: '全球旅游货仓平台规则(211112)',
          date: '2021年11月12日',
          path: 'https://qnimg.zowoyoo.com/10000/gtpw_pop_config/1636684214206_982.pdf'
        }
      ]
    }
  ];

  clickItem (path): void {
    window.open(path)
  }
}
